import { Language } from '@/store/user/types'

export const AppziSurveysIds = {
  [Language.Russian]: {
    FILLING_DETAILS: '478640e0-79dc-4a48-b91b-8d65eb7ead6b',
    PROFORMA_INVOICE: '4eec39d2-4c41-43b7-a420-a159bbf3a7c9',
    CARD_PAYMENT_COMPLETED: 'ee6f4b6d-e45c-4bb8-996c-1e302a7c77f3',
    BUDGET_ALLOCATION: 'c713ba55-58e6-4b3c-b72b-41f3611c5bfd',
    APPLICATION_SUBMITTED: '21119802-c85d-4956-834e-53685a071261',
  },
  [Language.English]: {
    FILLING_DETAILS: 'e601953a-4dae-455f-a516-b3b98603be26',
    PROFORMA_INVOICE: '5ab1e9db-87b0-47e0-bc78-928eec5b57a7',
    CARD_PAYMENT_COMPLETED: '74229e59-41a9-4dac-a625-5c499ee70ec3',
    BUDGET_ALLOCATION: '868e74e3-bb00-4f68-a4af-4ae346030d66',
    APPLICATION_SUBMITTED: 'f3f0ae2b-8297-4094-9695-786a98af2505',
  },
}

export type AppziSurveyIdType = (typeof AppziSurveysIds)[Language][keyof (typeof AppziSurveysIds)[Language]]

export enum SurveysKeys {
  PROFILE_ID = 'profile_id',
}

export type AppziEventParamsTypes = {
  [key in SurveysKeys]?: string | number | null
}
